var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('i',{staticClass:"icon-presence-check icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.$getText('AULA_NOTIFICATION_CANCELLED'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }